import { useTranslation } from 'react-i18next'

import translations from '@translationKeys'
import { Nullable } from '@types'

import { ActionsContainer } from '@components/ConfirmPopover'
import RadioList, { RadioItem } from '@components/RadioList'
import Button from '@components/formControls/Button'
import { Typography } from '@mui/material'

import { IMPORT_PROSPECT_TITLES_MAP } from './constant'
import { ImportProspectsView } from './types'

interface EventSelectionViewProps {
  events: RadioItem[]
  selectedEventId: Nullable<string>
  onSelectEvent: (eventId: string) => void
  onConfirm: () => void
  onCancel: () => void
}

const EventSelectionView = ({ events, selectedEventId, onSelectEvent, onConfirm, onCancel }: EventSelectionViewProps) => {
  const { t } = useTranslation()

  return (
    <>
      <Typography variant="h2" sx={{ paddingBottom: '10px', maxWidth: '300px' }}>
        {t(IMPORT_PROSPECT_TITLES_MAP[ImportProspectsView.event])}
      </Typography>

      <RadioList alignLeft value={selectedEventId} onChange={onSelectEvent} items={events} />

      <ActionsContainer>
        <Button variant="outlined" onClick={onCancel}>
          {t(translations.CANCEL_BUTTON)}
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={!selectedEventId}>
          {t(translations.CONFIRM_BUTTON)}
        </Button>
      </ActionsContainer>
    </>
  )
}

export default EventSelectionView
